module.exports = __webpack_public_path__ + "static/img/core.6a787764.png";